<template>
  <div>
    <div class="aite-desc" @click="showDialog">@（通知TA）</div>
    <el-dialog
      append-to-body
      width="500px"
      title=""
      :visible.sync="visible"
      destroy-on-close
      :before-close="reset"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <template #title>
        <div class="el-dialog-title">@（通知TA）</div>
      </template>
      <el-select
        @change="personChange"
        multiple
        style="width: 100%"
        v-model="aiteIdList"
        placeholder="请选择"
        filterable
        clearable
      >
        <el-option
          v-for="(staffItem, staffIndex) in employeeAllArr"
          :key="staffIndex"
          :label="staffItem.name"
          :value="staffItem.id"
          :disabled="staffItem.freeze_status == 2 ? true : false"
        >
          <span style="float: left">{{ staffItem.name }}</span>
          <span
            style="
              margin-left: 10px;
              float: right;
              color: #8492a6;
              font-size: 13px;
              text-align: right;
              max-width: 280px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            "
            >{{ staffItem.title }}</span
          >
        </el-option>
      </el-select>
      <template #footer>
        <el-row type="flex" justify="end">
          <el-button @click="reset">取消</el-button>
          <el-button type="primary" @click="save">完成</el-button>
        </el-row>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ["value"],
  data() {
    return {
      visible: false,
      aiteIdList: this.value,
      personObjList: [],
      employeeAllArr: [],
    };
  },
  methods: {
    showDialog() {
      this.visible = true;
    },
    getEmployeeAll() {
      this.$http
        .get("/admin/employee/all", {
          params: { status: 1, show_department: 1 },
        })
        .then((res) => {
          if (res.code == 1) {
            this.employeeAllArr = res.data.list;
          }
        });
    },
    personChange() {
      this.personObjList = this.employeeAllArr.filter((item) => {
        return this.aiteIdList.includes(item.id);
      });
    },
    save() {
      if (this.aiteIdList.length) {
        console.log(this.aiteIdList);
        console.log(this.personObjList);
        this.$emit("input", this.aiteIdList);
        this.$emit("change", this.personObjList);
        this.reset();
      } else {
        this.$message.error("请选择人员");
      }
    },
    reset() {
      this.visible = false;
    },
  },
  mounted() {
    this.getEmployeeAll();
  },
  watch:{
    value(val) {
      this.aiteIdList = val;
    },
  }
};
</script>

<style lang="scss" scoped>
.aite-desc {
  color: #999;
  cursor: pointer;
  padding: 10px 0px;
}
</style>